import React, { useEffect } from 'react';

import { Path, useFormContext } from 'react-hook-form';

import { z } from 'zod';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import {
  FormControl,
  FormField,
  FormItem,
  FormMessage
} from '../../../../../../components/ui/form';
import { EPagesVisibilityOptions, visibilityOptions } from '../../../constants';
import { pageFormSchema } from '../../../validation-schema';

type PageFormType = z.infer<typeof pageFormSchema>;

interface BlockVisibilityFieldProps {
  basePath: string;
  disabled?: boolean;
}

export const BlockVisibilityField: React.FC<BlockVisibilityFieldProps> = ({
  disabled = false,
  basePath
}) => {
  const { control, watch, setValue } = useFormContext<PageFormType>();

  const visibilityPath = `${basePath}.visibility` as Path<PageFormType>;
  const currentVisibility = watch(visibilityPath) as
    | EPagesVisibilityOptions
    | undefined;

  useEffect(() => {
    if (currentVisibility === undefined) {
      setValue(visibilityPath, EPagesVisibilityOptions.PUBLIC, {
        shouldValidate: false
      });
    }
  }, [currentVisibility, visibilityPath, setValue]);

  return (
    <FormField
      control={control}
      name={visibilityPath}
      render={({ field: { onChange } }) => (
        <FormItem>
          <FormControl>
            <InputSelectDropdown
              disabled={disabled}
              isRequired
              label="Visibility"
              defaultSelected={
                visibilityOptions.find(
                  (option) => option.value === currentVisibility
                ) ?? visibilityOptions[0]
              }
              options={visibilityOptions}
              onOptionChange={onChange}
              buttonDataTestId="PagesForm-Select-BlockVisibility"
              listDataTestId="PagesForm-Select-BlockVisibility-List"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
